export const LAYOUT = {
  DRAWER_WIDTH: 240,
  APP_TITLE: 'Abetting Screener',
  ROUTES: {
    SCREENER: '/screener',
    VIRTUAL_SESSIONS: '/virtual_sessions',
    DETAILED_VIRTUAL_SESSIONS: '/virtual_sessions/:id',
    // AGB-497 (AGB-490 rework): prematch virtual sessions, their own pages.
    PREMATCH_SESSIONS: '/prematch_sessions',
    // AGB-501: the prematch list is the Прематч tab of the virtual sessions.
    PREMATCH_SESSIONS_LIST: '/virtual_sessions?phase=prematch',
    DETAILED_PREMATCH_SESSIONS: '/prematch_sessions/:id',
    // AGB-502: cross-session analytics (Live / Прематч tabs).
    SESSION_ANALYTICS: '/session_analytics',
    REAL_SESSIONS: '/real_sessions',
    DETAILED_REAL_SESSIONS: '/real_sessions/:id',
    REAL_SESSION_FINANCE_WALLETS: '/real_sessions/:id/finance/wallets',
    REAL_SESSION_FINANCE_TRANSACTIONS: '/real_sessions/:id/finance/transactions',
    REAL_ACCOUNTS: '/real_accounts',
    CALIBRATION: '/calibration',
    FLEET_HEALTH: '/fleet_health',
    APPROVALS: '/approvals',
    ALERT_RULES: '/alert_rules',
    AUDIT_LOG: '/audit_log',
    MAINTENANCE: '/maintenance',
    LOGIN: '/login',
  },
}

export const DARK_MODE_BUTTON_LABEL = 'Dark'
export const LIGHT_MODE_BUTTON_LABEL = 'Light'